module.exports = __webpack_public_path__ + "img/true.a089cbec.svg";